import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import SettlementListComponent from '../../../components/Settlements/SettlementList/SettlementList.Component';

////i18Next
import { useTranslation } from 'react-i18next';

import './SettlementList.Styles.css';

export const SettlementListPage = () => {
  const [t] = useTranslation();

  return (
    <>
      <PageHeader eyebrow="Finanzas" title={t('settlementListPage.settlementListTitle')} />
      <div className="slp-page">
        <SettlementListComponent />
      </div>
    </>
  );
};
